<template>
    <header id="header-m">
        <div class="menu">
            <ul>
                <li  style="animation-delay: 0s"><a href="/home.html">{{$t(`header.home`)}}</a></li>
                <li style="animation-delay: 0.1s"><a href="/about.html">{{$t(`header.about`)}}</a></li>
                <li style="animation-delay: 0.2s"><a href="/product.html">{{$t(`header.product`)}}</a></li>
                <li style="animation-delay: 0.3s" v-if="$i18n.locale === 'zh'"><a href="/gover.html">投资者关系</a></li>
                <li style="animation-delay: 0.4s"><a href="/news.html?type=1">{{$t(`header.news`)}}</a></li>
                <li style="animation-delay: 0.5s"><a href="/searchCoa.html">{{$t(`header.search`)}}</a></li>
                <li style="animation-delay: 0.5s"><a href="/service.html">{{$t(`header.services`)}}</a></li>
                <li style="animation-delay: 0.5s" v-if="$i18n.locale === 'zh'"><a href="https://www.youliao.com">{{$t(`header.mall`)}}</a></li>
                <!-- <li style="animation-delay: 0.5s"><a href="/contact.html">{{$t(`contact.title`)}}</a></li> -->
            </ul>
            <div class="lan" style="animation-delay: 0.8s" >
                <span @click.prevent="changeLang('CN')">CN</span>
                <span @click.prevent="changeLang('EN')">EN</span>
            </div>
        </div>
    </header>
</template>

<script>
    import Scrollbar from 'smooth-scrollbar';
    export default {
        data(){
            return{
            }
        },
        methods: {
            changeLang(type) {
                const lang = type === "CN" ?  "zh" : "en"
                sessionStorage.setItem("lang", lang);
                // console.log(window.location, 12345555)
                this.$i18n.locale = lang;
                window.open(`./home.html` , "_self")
                // location.reload();
            },
        }
    }
</script>

<style scoped>
    header{
        color: #37383a;
        vertical-align: baseline;
        position: fixed;
        z-index: 1000;
        height: 100vh;
        -webkit-transition: all .7s cubic-bezier(.645,.045,.355,1);
        transition: all .7s cubic-bezier(.645,.045,.355,1);
        width: 50%;
        -webkit-transform: translateX(280px);
        transform: translateX(280px);
        right: -50%;
        top: 0;
    }
    header  .menu ul li{
        padding: 12px 0;
        text-transform: uppercase;
        font-family: SourceHanSerifCN-Regular;
        opacity: 0;
        transition: all 0.8s;
    }
    header .menu ul li a{
        color:white;
        font-size: 12px;
    }
    header .menu .lan{
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top:20px;
    }
    header .menu .lan span{
        display: inline-block;
        width:20%;
        text-align: center;
        color:white;
        font-size: 12px;
    }
    header .menu ul{
        display: block;
        font-size: 18px;
        width:100%;
        padding: 18px 0px;
        text-align: center;
        list-style: none;
    }
    .show{
        transform: translatex(0) rotateY(-30deg);
        right: -2.5%;
        background-color: #000;
    }
    .show .menu ul li{
        animation: goShow forwards 1s linear;
        opacity: 1;
    }
    .show .menu .lan{
        animation: goShow forwards 1s linear;
        opacity: 1;
    }
    @keyframes goShow {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }


</style>
